import ReactQuill from 'react-quill'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

import 'react-quill/dist/quill.snow.css'

const Editor = ({value, setValue}) => {
  return (
    <Box
      sx={{
        '.ql-editor p': {
          marginBottom: '10px',
          marginTop: '10px',
        },
        '.ql-editor p:nth-last-of-type(-n+3)': {
          marginBottom: '0px !important',
          marginTop: '0px !important',
        },
      }}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={setValue}
        modules={Editor.modules}
        formats={Editor.formats}
      />
    </Box>
  )
}

Editor.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
}

// For all module options...
// https://quilljs.com/docs/modules/toolbar

Editor.modules = {
  toolbar: [
    [{header: [1, 2, 3, 4, false]}],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{list: 'ordered'}, {list: 'bullet'}],
    [{color: []}, {background: []}],
    ['link'],
  ],
}

Editor.formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'color',
  'background',
  'link',
]

export default Editor
